import { Link, useParams } from "react-router-dom";
import { Users, GitCompare, Library, ClipboardCheck, Video, BarChart3, FileQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState, PageHeader } from "@/components/app/Common";

const INFO = {
  candidates: { icon: Users, title: "Candidates", text: "Candidates appear here once you add resumes to a job. Resume upload and AI screening arrive in the next phase." },
  compare: { icon: GitCompare, title: "Compare candidates", text: "Pick two to four candidates from a job to compare their scores side by side." },
  "talent-pool": { icon: Library, title: "Talent pool", text: "Strong past candidates will be saved here so you can reach out when a matching role opens." },
  assessments: { icon: ClipboardCheck, title: "Assessments", text: "Personality assessments and work samples you send to candidates will be tracked here." },
  interviews: { icon: Video, title: "Interviews", text: "AI interview invitations, recordings and scores will be listed here." },
  reports: { icon: BarChart3, title: "Reports", text: "Hiring funnel, time-to-shortlist and fairness reports will appear once candidates start flowing." },
};

export function ModulePlaceholder({ module }) {
  const i = INFO[module];
  return (
    <div className="space-y-6" data-testid={`${module}-page`}>
      <PageHeader title={i.title} />
      <EmptyState
        testId={`${module}-empty`}
        icon={i.icon}
        title="Nothing here yet"
        text={i.text}
        action={<Button asChild variant="outline"><Link to="/app/jobs">Go to jobs</Link></Button>}
      />
    </div>
  );
}

export function CandidateDetail() {
  const { id, tab } = useParams();
  return (
    <div className="space-y-6" data-testid="candidate-detail-page">
      <PageHeader title="Candidate profile" subtitle={`Candidate ${id} · ${tab}`} />
      <EmptyState icon={Users} title="Candidate profiles arrive in the next phase" text="You'll see the resume, Fit Score breakdown, assessments and interview here." />
    </div>
  );
}

export function NotFound() {
  return (
    <EmptyState
      testId="not-found"
      icon={FileQuestion}
      title="We couldn't find that page"
      text="The link may be out of date."
      action={<Button asChild variant="outline"><Link to="/app">Back to dashboard</Link></Button>}
    />
  );
}
